import { afterRenderEffect, Directive, ElementRef, inject, NgZone, OnDestroy, signal } from '@angular/core';

@Directive({
  selector: '[gcTruncationDetector]',
  standalone: true,
  exportAs: 'gcTruncationDetector',
})
export class TruncationDetectorDirective implements OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private ngZone = inject(NgZone);

  readonly isTruncated = signal(false);

  private observer = new ResizeObserver(() => this.ngZone.run(() => this.update()));

  constructor() {
    this.ngZone.runOutsideAngular(() => this.observer.observe(this.el.nativeElement));
    afterRenderEffect(() => this.update());
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  private update(): void {
    const el = this.el.nativeElement;
    const truncated = el.scrollHeight > el.clientHeight;

    if (truncated !== this.isTruncated()) {
      this.isTruncated.set(truncated);
    }
  }
}
